module.exports = __webpack_public_path__ + "static/media/indoor_modbus_rtu.e1ded193.md";